import React from 'react';
import styles from './RouteMapPlaceholder.module.css';

export const RouteMapPlaceholder: React.FC = () => {
  const stops = Array.from({ length: 8 }, (_, i) => i + 1);
  return (
    <div className={styles.map}>
      <div className={styles.mapBg} />
      <div className={styles.tagsRow}>
        <span className={`${styles.tag} ${styles.tagDone}`}>✓ Completed: Quick Mart Downtown</span>
        <span className={`${styles.tag} ${styles.tagNext}`}>2 Next Stop: Corner Store Express</span>
        <span className={`${styles.tag} ${styles.tagThen}`}>3 Then: Main Street Market</span>
      </div>
      <div className={styles.pinsRow}>
        {stops.map((n) => {
          let color = 'pinPending';
          if (n === 1) color = 'pinDone';
          else if (n === 2) color = 'pinActive';
          else if (n === 3) color = 'pinNext';
          return (
            <span key={n} className={`${styles.pin} ${styles[color]}`}>
              {n}
            </span>
          );
        })}
      </div>
    </div>
  );
};
